/* global analytics */
import React, { useState, useEffect } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { filter, findIndex, includes } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { slide as Menu } from 'react-burger-menu';
import PropTypes from 'prop-types';

import withStatsig from '../hocs/withStatsig';
import LearnMoreUtrCollegePopUp from '../Upgrade/UpgradeToUtrCollege/LearnMoreUtrCollegePopUp';
import UpgradeToPerformanceHsPopUp from '../Upgrade/UpgradeToPerformanceHs/UpgradeToPerformanceHsPopUp';
import UpgradeToProClubPopUp from '../Upgrade/UpgradeToProClubPopUp';
import MenuLink from './MenuLink';
import TrackedClick, { trackEvent } from '../Analytics/TrackedClick';

import { fetchComponentConfig } from '../../actions/component-config-actions';
import { setMenuState } from '../../actions/menu-actions';
import { postComponentAction } from '../../api/componentConfigApi';
import { getClubTypeString, isFreeCollegeClub, isCollegeClub, getClubsVisibleToUser, sortClubMembershipsByPaidHit } from '../../utils/clubs';
import { userIsFreeCollegeClubOwner, userIsClubAdminOrOwner, userIsFreeHighSchoolClubOwner } from '../../utils/user';
import { getSavedPlayersMenuPath } from '../../utils/savedLists';
import { getActiveLeagueTeams } from '../../actions/leagues-actions';
import { getApiAxiosInstance } from '../../utils/network';
import useIsMobile from '../hooks/useIsMobile';
import { useLogout } from '../hooks/useLogout';
import { getClickAttrs } from '../Analytics/gtag';

import { sportTypeIds } from '../../utils/eventConstants';
import config from '../../../config';
import links from '../../../config/links';

import styles from './menu.scss';
import { rightSidebarNavIDs } from '../Analytics/testIDConfig';

const { TENNIS, PICKLEBALL } = sportTypeIds;
const { marketingAppHost, isLocalhost } = config;

const _ = { filter, findIndex, includes };

const SlideMenu = (props) => {
    const [collapsed, setCollapsed] = useState(false);
    const [showLearnMoreUtrCollegePopup, setShowLearnMoreUtrCollegePopup] = useState(false);
    const [showUpgradeToPerformanceHsPopup, setShowUpgradeToPerformanceHsPopup] = useState(false);
    const [showProClubPopup, setShowProClubPopup] = useState(false);
    const [clubToUpgrade, setClubToUpgrade] = useState(null);
    const [toggleMyProfile, setToggleMyProfile] = useState(false);
    const [toggleMyAccount, setToggleMyAccount] = useState(false);
    const maxLeagueTeamsToDisplay = 3;

    const { isMobileWidth } = useIsMobile();

    const auth = useSelector(({ auth }) => auth);
    const componentConfig = useSelector(({ componentConfig }) => componentConfig);
    const leagues = useSelector(({ leagues }) => leagues);
    const menu = useSelector(({ menu }) => menu);
    const dispatch = useDispatch();

    const { user } = auth;
    const { activeTeams, isActiveTeamsLoaded } = leagues;
    const { logoutUser } = useLogout();

    // TODO: figure out a better way for only firing once
    useEffect(() => {
        if (auth.user) {
            dispatch(fetchComponentConfig('side-menu', {}));
        }
        if (auth.user && !isActiveTeamsLoaded) {
            dispatch(getActiveLeagueTeams());
        }
    }, []);

    const handleLogOut = async (ev) => {
        if (ev) {
            ev.preventDefault();
        }
        logoutUser();
    };

    const handleMenuStateChange = (state) => {
        dispatch(setMenuState(state.isOpen));
    };

    const handleClose = () => {
        dispatch(setMenuState(false));
    };

    const handleCollapse = () => {
        setCollapsed(!collapsed);
    };

    const handlePowerClick = () => {
        if (auth.user?.isPowered) {
            // segment call - mapped to GA4
            trackEvent(`Power Perks Nav Flyout Power Active Entrypoint Click Segment`, {
                page: 'Home',
                button: 'Power Perks',
                action: 'click',
            });
        } else {
            // segment call - mapped to GA4
            trackEvent(`Power Perks Nav Flyout Entrypoint Click Segment`, {
                page: 'Home',
                button: 'Power Perks',
                action: 'click',
            });
        }
        props.history.push('/power-perks');
    };

    const getPowerClickDataAttrs = () => {
        if (auth.user?.isPowered) {
            return {
                'data-category': 'Power Perks',
                'data-context': `Power Perks Nav Flyout Power Active Entrypoint Click`,
                'data-location': 'Power Perks Nav Flyout',
            };
        }
        return {
            'data-category': 'Power Upgrade',
            'data-context': `Power Perks Nav Flyout Entrypoint Click`,
            'data-location': 'Power Perks Nav Flyout',
        };
    };

    const handleProClubSuccess = () => {
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };

    const handleToggleMyProfile = () => {
        setToggleMyProfile(!toggleMyProfile);
    };

    const handleToggleMyAccount = () => {
        setToggleMyAccount(!toggleMyAccount);
    };

    const referralsEnabled = props.checkGate(props.featureGates.REFERRAL_SYSTEM);
    const powerReferralBadge = props.checkGate(props.featureGates.POWER_REFERRAL_NEW_BADGE);
    const savedListEnabled = props.checkGate(props.featureGates.SAVED_PLAYER_LIST_ROLLOUT);
    const savedPlayersPath = getSavedPlayersMenuPath(savedListEnabled, user?.claimedPlayer);
    const { pathname } = props.location;
    const { open } = menu;
    const visibleClubs = user?.clubMemberships ? getClubsVisibleToUser(user?.clubMemberships) : [];
    const clubTiers = ['Pro', 'Special', 'Free College', 'High School', 'Pro College'];
    const clubMembershipsAdminOrOwnerRole = user ? _.filter(visibleClubs,
        clubMembership => clubMembership.roleValue === 'Admin' || clubMembership.roleValue === 'Owner') : [];
    const clubMembershipsMemberRole = user ? _.filter(visibleClubs, ['roleValue', 'Member']) : [];
    const userIsFreeCollegeClubOwnerValue = user && userIsFreeCollegeClubOwner(user);
    const isPremiumClubsOrganiser = clubMembershipsAdminOrOwnerRole && (_.findIndex(clubMembershipsAdminOrOwnerRole, (o) => _.includes(clubTiers, o.tierTypeName)) !== -1);
    const clubMembershipsOrderedByAdminOwnerFirst = clubMembershipsAdminOrOwnerRole.concat(clubMembershipsMemberRole);
    const sortedClubMemberships = sortClubMembershipsByPaidHit(clubMembershipsOrderedByAdminOwnerFirst);
    const clubMembershipsToDisplay = [];

    if (sortedClubMemberships && sortedClubMemberships.length > 2) {
        for (const membership of sortedClubMemberships.slice(0, 2)) {
            clubMembershipsToDisplay.push(membership);
        }
    } else {
        for (const membership of sortedClubMemberships) {
            clubMembershipsToDisplay.push(membership);
        }
    }

    const getFreeOwnerHsClubForUpgrade = () => {
        return user?.clubMemberships?.filter(() => {
            // is user FreeHighSchoolOwner
            return user && userIsFreeHighSchoolClubOwner(user);
        });
    };
    const canUpgradeToPerformanceHs = () => {
        const clubOwnerHsClubs = getFreeOwnerHsClubForUpgrade();
        return !!(clubOwnerHsClubs && clubOwnerHsClubs.length > 0);
    };

    const UpgradeToPowerLink = () => {
        return (
            <a
                className={`${styles.menuItem} ${pathname === '/power-perks' ? styles.active : ''}`}
                href="#"
                onClick={(ev) => {
                    ev.preventDefault();
                    handlePowerClick();
                }}
                {...getPowerClickDataAttrs()}
                {...getClickAttrs({
                    category: 'powerPerks',
                    context: `powerPerks link`,
                    location: 'Menu',
                    testid: `${rightSidebarNavIDs.powerPerks.component}-${rightSidebarNavIDs.powerPerks.location}-${rightSidebarNavIDs.powerPerks.id}`,
                })}
            >
                Power Perks
            </a>
        );
    };

    const UpgradeToUTRCollegeLink = () => (
        <a
            className={styles.menuItem}
            href="#"
            onClick={() => {
                const clubOwnerAdminCollegeClubs = visibleClubs.filter((clubMembership) => {
                    return isCollegeClub(clubMembership.tierTypeName) && userIsClubAdminOrOwner(clubMembership);
                });
                if (clubOwnerAdminCollegeClubs.length > 1) {
                    props.history.push('/clubs');
                } else {
                    setShowLearnMoreUtrCollegePopup(true);
                }
            }}
            {...getClickAttrs({
                category: 'collegeCoachSub',
                context: `collegeCoachSub link`,
                location: 'Menu',
                testid: `${rightSidebarNavIDs.collegeCoachSub.component}-${rightSidebarNavIDs.collegeCoachSub.location}-${rightSidebarNavIDs.collegeCoachSub.id}`,
            })}
        >
            + Upgrade to College Coach Subscription
        </a>
    );

    const UpgradeToPerformanceHsLink = () => (
        <a
            className={styles.menuItem}
            href="#"
            onClick={() => {
                const clubOwnerHsClubs = getFreeOwnerHsClubForUpgrade();
                if (clubOwnerHsClubs.length > 1) {
                    props.history.push('/clubs');
                } else {
                    setShowUpgradeToPerformanceHsPopup(true);
                }
            }}
            {...getClickAttrs({
                category: 'performanceHighSchool',
                context: `performanceHighSchool link`,
                location: 'Menu',
                testid: `${rightSidebarNavIDs.performanceHighSchool.component}-${rightSidebarNavIDs.performanceHighSchool.location}-${rightSidebarNavIDs.performanceHighSchool.id}`,
            })}
        >
            + Upgrade to Performance High School
        </a>
    );

    const getCurrentFreeCollegeClubAsOptionToUpgrade = () => {
        const clubOwnerAdminFreeCollegeClubs = visibleClubs.filter((clubMembership) => {
            return isFreeCollegeClub(clubMembership.tierTypeName) && userIsClubAdminOrOwner(clubMembership);
        });
        if (clubOwnerAdminFreeCollegeClubs.length > 0) {
            return clubOwnerAdminFreeCollegeClubs.map((clubMembership) => {
                return {
                    value: clubMembership.clubId,
                    label: clubMembership.name,
                };
            });
        }
        return null;
    };

    const getCurrentFreeHighSchoolClubAsOptionToUpgrade = () => {
        const clubOwnerHsClubs = getFreeOwnerHsClubForUpgrade();
        if (clubOwnerHsClubs.length > 0) {
            return clubOwnerHsClubs.map((clubMembership) => {
                return {
                    value: clubMembership.clubId,
                    label: clubMembership.name,
                };
            });
        }

        return null;
    };

    const sideMenuCompConfig = componentConfig['side-menu'];
    const sideMenuCompConfigLegacyReports = sideMenuCompConfig?.modals?.find(m => m?.type === 'search_page_from_legacy_report_links');
    const axiosInstance = getApiAxiosInstance();

    return (
        <>
            <Menu
                right
                isOpen={open}
                onStateChange={handleMenuStateChange}
                customBurgerIcon={false}
                className="menu-new"
                width={isMobileWidth ? '100%' : '300px'}
            >
                <div className={styles.closeArea}>
                    <button
                        type="submit"
                        className={styles.closeBtn}
                        onClick={handleClose}
                        {...getClickAttrs({
                            category: 'close btn click',
                            context: `close btn`,
                            location: 'Menu',
                            testid: `${rightSidebarNavIDs.closeBtn.component}-${rightSidebarNavIDs.closeBtn.location}-${rightSidebarNavIDs.closeBtn.id}`,
                        })}
                    >
                        <span />
                        <span />
                    </button>
                </div>
                <div className={styles.menuSection_options}>
                    {user?.firstName ? <h6 data-testid="menu.header.user-name">{user.firstName} {user.lastName}</h6> : <div className="fs20 fw400 text-dark" data-testid="menu.header.welcome-msg">Welcome to UTR Sports</div>}
                    <div className={styles.divider} />
                    {user && !user.onboardingCompleted && user.onboardingRequired && pathname === `/` &&
                        (
                            <div onClick={handleClose}>
                                <Link
                                    className={`${styles.menuItem}`}
                                    onClick={(ev) => {
                                        ev.preventDefault();
                                        props.history.push(ev.target.pathname);
                                    }}
                                    to="/home"
                                    {...getClickAttrs({
                                        category: 'Menu',
                                        context: 'Menu Item - Home',
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.home.component}-${rightSidebarNavIDs.home.location}-${rightSidebarNavIDs.home.id}`,
                                    })}
                                >
                                    Home
                                </Link>
                            </div>
                        )}
                </div>
                {user && (user.onboardingCompleted || !user.onboardingRequired) && (
                    <div className={`${styles.playerDetails} d-none d-lg-block`} data-testid="menu.player-details">
                        <div onClick={handleClose}>
                            {user.claimedPlayer && (
                                <MenuLink
                                    path={`/players/${user.claimedPlayer.playerId}`}
                                    text={'Profile'}
                                    {...getClickAttrs({
                                    category: 'profile',
                                    context: `profile link`,
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.profile.component}-${rightSidebarNavIDs.profile.location}-${rightSidebarNavIDs.profile.id}`,
                                })}
                                />
                            )}
                            <MenuLink
                                path={`/settings/account`}
                                text={'Settings'}
                                {...getClickAttrs({
                                category: 'settings',
                                context: `settings link`,
                                location: 'Menu',
                                testid: `${rightSidebarNavIDs.settings.component}-${rightSidebarNavIDs.settings.location}-${rightSidebarNavIDs.settings.id}`,
                            })}
                            />
                            {referralsEnabled && (
                                <Link
                                    className={styles.menuItem}
                                    to="/refer-friends/member"
                                    {...getClickAttrs({
                                        category: 'referral',
                                        context: `referral link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.referral.component}-${rightSidebarNavIDs.referral.location}-${rightSidebarNavIDs.referral.id}`,
                                    })}
                                >
                                    Refer a Friend
                                    {powerReferralBadge && (
                                        <span className={styles.newBadge} data-testid="menu.refer-friends.new-badge">NEW</span>
                                    )}
                                </Link>
                            )}
                            {(user.isPowered || user.isProClubHeadOrganizer || user.hasPastDueSubscription) && (
                                <MenuLink
                                    path={`/subscriptions`}
                                    text={'Subscriptions'}
                                    {...getClickAttrs({
                                    category: 'subscriptions',
                                    context: `subscriptions link`,
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.subscriptions.component}-${rightSidebarNavIDs.subscriptions.location}-${rightSidebarNavIDs.subscriptions.id}`,
                                })}
                                />
                            )}
                            {userIsFreeCollegeClubOwnerValue ? <UpgradeToUTRCollegeLink /> : <UpgradeToPowerLink />}
                            {canUpgradeToPerformanceHs() && (
                                <UpgradeToPerformanceHsLink />
                            )}
                        </div>
                    </div>
                )}
                {user && (user.onboardingCompleted || !user.onboardingRequired) && (
                    <div className={`${styles.menuSection} d-block d-lg-none`}>
                        <div onClick={() => handleToggleMyProfile()} className={styles.menuTitle} data-testid="menu.my-profile.toggle-btn">My Profile <span>{toggleMyProfile ? '-' : '+'}</span></div>
                        {toggleMyProfile && (
                            <div className={styles.collapsible} onClick={handleClose}>
                                {user.claimedPlayer && (
                                    <MenuLink
                                        path={`/players/${user.claimedPlayer.playerId}`}
                                        text={'Profile'}
                                        {...getClickAttrs({
                                        category: 'claimedPlayerProfile',
                                        context: `claimedPlayerProfile link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.claimedPlayerProfile.component}-${rightSidebarNavIDs.claimedPlayerProfile.location}-${rightSidebarNavIDs.claimedPlayerProfile.id}`,
                                    })}
                                    />
                                )}
                                <MenuLink
                                    path={`/clubs`}
                                    text={'My Clubs & Teams'}
                                    trackedContent={'My Clubs'}
                                    {...getClickAttrs({
                                        category: 'myClubs',
                                        context: `myClubs link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.myClubs.component}-${rightSidebarNavIDs.myClubs.location}-${rightSidebarNavIDs.myClubs.id}`,
                                    })}
                                />
                                <MenuLink
                                    path={`/my-group`}
                                    text={'My Player Group'}
                                    {...getClickAttrs({
                                        category: 'myPlayerGroup',
                                        context: `myPlayerGroup link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.myPlayerGroup.component}-${rightSidebarNavIDs.myPlayerGroup.location}-${rightSidebarNavIDs.myPlayerGroup.id}`,
                                    })}
                                />
                                {user.isPowered && (
                                    <div className="">
                                        <MenuLink
                                            path={savedPlayersPath}
                                            text={'My Saved Players'}
                                            section={'Menu - Saved Lists'}
                                            {...getClickAttrs({
                                            category: 'mySavedPlayers',
                                            context: `mySavedPlayers link`,
                                            location: 'Menu',
                                            testid: `${rightSidebarNavIDs.mySavedPlayers.component}-${rightSidebarNavIDs.mySavedPlayers.location}-${rightSidebarNavIDs.mySavedPlayers.id}`,
                                        })}
                                        />
                                        {!savedListEnabled && (
                                            <MenuLink
                                                path={`/saved/schools`}
                                                text={'My Saved Schools'}
                                                section={'Menu - Saved Lists'}
                                                {...getClickAttrs({
                                                    category: 'mySavedSchools',
                                                    context: `mySavedSchools link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.mySavedSchools.component}-${rightSidebarNavIDs.mySavedSchools.location}-${rightSidebarNavIDs.mySavedSchools.id}`,
                                                })}
                                            />
                                        )}
                                        {sideMenuCompConfigLegacyReports && (
                                            <>
                                                <TrackedClick
                                                    eventName="Menu Cta Clicked"
                                                    label="College Report"
                                                    traits={
                                                        {
                                                            sectionName: 'Menu - Saved Lists',
                                                            content: 'College Report',
                                                        }
}
                                                >
                                                    <Link
                                                        className={styles.menuItem}
                                                        to={`/search?type=colleges&welcome_reports=true`}
                                                        onClick={async (ev) => {
                                                            ev.preventDefault();
                                                            await postComponentAction(axiosInstance, 'side-menu', sideMenuCompConfigLegacyReports.actions.dismissed.event, {});
                                                            dispatch(fetchComponentConfig('side-menu', {}));
                                                            props.history.push('/search?type=colleges&welcome_reports=true');
                                                        }}
                                                        {...getClickAttrs({
                                                            category: 'Menu',
                                                            context: `College Report`,
                                                            location: 'Menu',
                                                            testid: `${rightSidebarNavIDs.collegeReport.component}-${rightSidebarNavIDs.collegeReport.location}-${rightSidebarNavIDs.collegeReport.id}`,
                                                        })}
                                                    >
                                                        College Report
                                                    </Link>
                                                </TrackedClick>
                                                <TrackedClick
                                                    eventName="Menu Cta Clicked"
                                                    label="Player Report"
                                                    traits={
                                                        {
                                                            sectionName: 'Menu - Saved Lists',
                                                            content: 'Player Report',
                                                        }
}
                                                >
                                                    <Link
                                                        className={styles.menuItem}
                                                        to={`/search?type=players&welcome_reports=true`}
                                                        onClick={async (ev) => {
                                                            ev.preventDefault();
                                                            await postComponentAction(axiosInstance, 'side-menu', sideMenuCompConfigLegacyReports.actions.dismissed.event, {});
                                                            dispatch(fetchComponentConfig('side-menu', {}));
                                                            props.history.push('/search?type=players&welcome_reports=true');
                                                        }}
                                                        {...getClickAttrs({
                                                            category: 'Menu',
                                                            context: `Player Report`,
                                                            location: 'Menu',
                                                            testid: `${rightSidebarNavIDs.playerReport.component}-${rightSidebarNavIDs.playerReport.location}-${rightSidebarNavIDs.playerReport.id}`,
                                                        })}
                                                    >
                                                        Player Report
                                                    </Link>
                                                </TrackedClick>
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}

                {user ? (
                    <div>
                        <div onClick={handleClose}>
                            <div className="d-none d-lg-block">
                                {(!!clubMembershipsToDisplay?.length || !!visibleClubs?.length || (!user.canCreateEvent && isPremiumClubsOrganiser)) && (
                                    <div className={styles.menuSection}>
                                        <div className={styles.menuTitle} data-testid="menu.clubs-teams-groups.section-title">Clubs, Teams & Groups</div>
                                        {clubMembershipsToDisplay.map((clubMembership) => (
                                            <MenuLink
                                                key={`${clubMembership.clubId}`}
                                                path={`/${getClubTypeString(clubMembership.tierTypeId)}/${clubMembership.clubId}`}
                                                text={clubMembership.name}
                                                trackedContent={`Individual clubs - ${clubMembership.name}`}
                                                {...getClickAttrs({
                                                    category: 'individualClubs',
                                                    context: `individualClubs link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.individualClubs.component}-${rightSidebarNavIDs.individualClubs.location}-${rightSidebarNavIDs.individualClubs.id}`,
                                                })}
                                            />
                                        ))}
                                        {(visibleClubs?.length) > 0 && (
                                            <MenuLink
                                                path={`/clubs`}
                                                text={'See All'}
                                                trackedContent={'See All Clubs'}
                                                {...getClickAttrs({
                                                category: 'seeAllClubs',
                                                context: `seeAllClubs link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.seeAllClubs.component}-${rightSidebarNavIDs.seeAllClubs.location}-${rightSidebarNavIDs.seeAllClubs.id}`,
                                            })}
                                            />
                                        )}
                                        {(!user.canCreateEvent && isPremiumClubsOrganiser) && (
                                            <Link
                                                className={`${styles.menuItem} ${pathname === '/create-event' ? styles.active : ''}`}
                                                to={`/create-event`}
                                                {...getClickAttrs({
                                                    category: 'createAnEvent',
                                                    context: `createAnEvent link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.createAnEvent.component}-${rightSidebarNavIDs.createAnEvent.location}-${rightSidebarNavIDs.createAnEvent.id}`,
                                                })}
                                            >
                                                Create an Event
                                            </Link>
                                        )}
                                    </div>
                                )}
                                {user && !!activeTeams?.tennis?.length && (
                                    <div className={styles.menuSection}>
                                        <div className={styles.menuTitle} data-testid="menu.team-tennis.section-title">TEAM TENNIS</div>
                                        {activeTeams.tennis.slice(0, maxLeagueTeamsToDisplay).map((team) => (
                                            <MenuLink
                                                key={`${team.teamId}`}
                                                path={`${config.leaguesAppHost}/teams/${team.teamId}`}
                                                text={team.teamName}
                                                isLeagueLink={true}
                                                trackedContent={`Active League Teams - ${team.teamName}`}
                                                {...getClickAttrs({
                                                    category: 'activeLeagueTeams',
                                                    context: `activeLeagueTeams link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.activeLeagueTeams.component}-${rightSidebarNavIDs.activeLeagueTeams.location}-${rightSidebarNavIDs.activeLeagueTeams.id}`,
                                                })}
                                            />
                                        ))}
                                        <MenuLink
                                            path={`${config.leaguesAppHost}/member-teams/sport/${TENNIS}`}
                                            text={'See All'}
                                            trackedContent={'See All League Tennis Teams'}
                                            isLeagueLink={true}
                                            {...getClickAttrs({
                                                    category: 'seeAllLeagueTeams',
                                                    context: `seeAllLeagueTeams link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.seeAllLeagueTeams.component}-${rightSidebarNavIDs.seeAllLeagueTeams.location}-${rightSidebarNavIDs.seeAllLeagueTeams.id}`,
                                                })}
                                        />
                                    </div>
                                )}
                                {user && !!activeTeams?.pickleball?.length && (
                                    <div className={styles.menuSection}>
                                        <div className={styles.menuTitle} data-testid="menu.team-pickleball.section-title">TEAM PICKLEBALL</div>
                                        {activeTeams.pickleball.slice(0, maxLeagueTeamsToDisplay).map((team) => (
                                            <MenuLink
                                                key={`${team.teamId}`}
                                                path={`${config.leaguesAppHost}/teams/${team.teamId}`}
                                                text={team.teamName}
                                                isLeagueLink={true}
                                                trackedContent={`Active League Teams - ${team.teamName}`}
                                                {...getClickAttrs({
                                                    category: 'activeLeagueTeamsPickelball',
                                                    context: `activeLeagueTeamsPickelball link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.activeLeagueTeamsPickelball.component}-${rightSidebarNavIDs.activeLeagueTeamsPickelball.location}-${rightSidebarNavIDs.activeLeagueTeamsPickelball.id}`,
                                                })}
                                            />
                                        ))}
                                        <MenuLink
                                            path={`${config.leaguesAppHost}/member-teams/sport/${PICKLEBALL}`}
                                            text={'See All'}
                                            trackedContent={'See All League Pickleball Teams'}
                                            isLeagueLink={true}
                                            {...getClickAttrs({
                                                category: 'seeAllPickelballTeams',
                                                context: `seeAllPickelballTeams link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.seeAllPickelballTeams.component}-${rightSidebarNavIDs.seeAllPickelballTeams.location}-${rightSidebarNavIDs.seeAllPickelballTeams.id}`,
                                            })}
                                        />
                                    </div>
                                )}
                                {user.isClubOrganizer && (
                                    <div className={`${styles.menuSection} d-block`}>
                                        <a
                                            className={`${styles.menuTitle}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            href={`https://support.${config.siteBaseUrl}/en/support/solutions/9000115381`}
                                            {...getClickAttrs({
                                                category: 'clubResourcesOrganizer',
                                                context: `clubResourcesOrganizer link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.clubResourcesOrganizer.component}-${rightSidebarNavIDs.clubResourcesOrganizer.location}-${rightSidebarNavIDs.clubResourcesOrganizer.id}`,
                                            })}
                                        >Club Resources
                                        </a>
                                    </div>
                                )}
                                <div className={styles.menuSection}>
                                    <MenuLink
                                        path={`/my-group`}
                                        text={'My Player Group'}
                                        {...getClickAttrs({
                                            category: 'myPlayerGroupCreatePlay',
                                            context: `myPlayerGroupCreatePlay link`,
                                            location: 'Menu',
                                            testid: `${rightSidebarNavIDs.myPlayerGroupCreatePlay.component}-${rightSidebarNavIDs.myPlayerGroupCreatePlay.location}-${rightSidebarNavIDs.myPlayerGroupCreatePlay.id}`,
                                        })}
                                    />
                                </div>
                                {user?.isPowered && (user?.onboardingCompleted || !user?.onboardingRequired) && (
                                    <div className={styles.menuSection}>
                                        <div className={styles.menuTitle} data-testid="menu.saved-lists.section-title">Saved Lists</div>
                                        <MenuLink
                                            path={savedPlayersPath}
                                            text={'Players'}
                                            section={'Menu - Saved Lists'}
                                            {...getClickAttrs({
                                                category: 'poweredPlayersSavedList',
                                                context: `poweredPlayersSavedList link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.poweredPlayersSavedList.component}-${rightSidebarNavIDs.poweredPlayersSavedList.location}-${rightSidebarNavIDs.poweredPlayersSavedList.id}`,
                                            })}
                                        />
                                        {!savedListEnabled && (
                                            <MenuLink
                                                path={`/saved/schools`}
                                                text={'Schools'}
                                                section={'Menu - Saved Lists'}
                                                {...getClickAttrs({
                                                    category: 'poweredSchoolsSavedList',
                                                    context: `poweredSchoolsSavedList link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.poweredSchoolsSavedList.component}-${rightSidebarNavIDs.poweredSchoolsSavedList.location}-${rightSidebarNavIDs.poweredSchoolsSavedList.id}`,
                                                })}
                                            />
                                        )}
                                        {sideMenuCompConfigLegacyReports && (
                                            <>
                                                <TrackedClick
                                                    eventName="Menu Cta Clicked"
                                                    label="College Report"
                                                    traits={
                                                        {
                                                            sectionName: 'Menu - Saved Lists',
                                                            content: 'College Report',
                                                        }
}
                                                >
                                                    <Link
                                                        className={styles.menuItem}
                                                        to={`/search?type=colleges&welcome_reports=true`}
                                                        onClick={async (ev) => {
                                                            ev.preventDefault();
                                                            await postComponentAction(axiosInstance, 'side-menu', sideMenuCompConfigLegacyReports.actions.dismissed.event, {});
                                                            dispatch(fetchComponentConfig('side-menu', {}));
                                                            props.history.push('/search?type=colleges&welcome_reports=true');
                                                        }}
                                                        {...getClickAttrs({
                                                            category: 'Menu',
                                                            context: `College Report`,
                                                            location: 'Menu',
                                                            testid: `${rightSidebarNavIDs.collegeReportLegacy.component}-${rightSidebarNavIDs.collegeReportLegacy.location}-${rightSidebarNavIDs.collegeReportLegacy.id}`,
                                                        })}
                                                    >
                                                        College Report
                                                    </Link>
                                                </TrackedClick>
                                                <TrackedClick
                                                    eventName="Menu Cta Clicked"
                                                    label="Player Report"
                                                    traits={
                                                        {
                                                            sectionName: 'Menu - Saved Lists',
                                                            content: 'Player Report',
                                                        }
}
                                                >
                                                    <Link
                                                        className={styles.menuItem}
                                                        to={`/search?type=players&welcome_reports=true`}
                                                        onClick={async (ev) => {
                                                            ev.preventDefault();
                                                            await postComponentAction(axiosInstance, 'side-menu', sideMenuCompConfigLegacyReports.actions.dismissed.event, {});
                                                            dispatch(fetchComponentConfig('side-menu', {}));
                                                            props.history.push('/search?type=players&welcome_reports=true');
                                                        }}
                                                        {...getClickAttrs({
                                                            category: 'Menu',
                                                            context: `Player Report`,
                                                            location: 'Menu',
                                                            testid: `${rightSidebarNavIDs.playerReportLegacy.component}-${rightSidebarNavIDs.playerReportLegacy.location}-${rightSidebarNavIDs.playerReportLegacy.id}`,
                                                        })}
                                                    >
                                                        Player Report
                                                    </Link>
                                                </TrackedClick>
                                            </>
                                        )}
                                    </div>
                                )}
                                <div className={styles.menuSection}>
                                    {user?.isAdmin && (
                                        <>
                                            <Link
                                                className={styles.menuItem}
                                                to="/impersonate"
                                                {...getClickAttrs({
                                                    category: 'impersonate',
                                                    context: `impersonate link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.impersonate.component}-${rightSidebarNavIDs.impersonate.location}-${rightSidebarNavIDs.impersonate.id}`,
                                                })}
                                            >Impersonate
                                            </Link>
                                            <Link
                                                className={styles.menuItem}
                                                to="/manage-event-templates"
                                                {...getClickAttrs({
                                                    category: 'manageTemplates',
                                                    context: `manageTemplates link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.manageTemplates.component}-${rightSidebarNavIDs.manageTemplates.location}-${rightSidebarNavIDs.manageTemplates.id}`,
                                                })}
                                            >Manage Templates
                                            </Link>
                                        </>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className={`${styles.menuSection} d-block d-lg-none`}>
                            <a
                                className={`${styles.menuTitle}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                href={`https://support.${config.siteBaseUrl}/en/support/solutions/9000115381`}
                                {...getClickAttrs({
                                    category: 'clubResources',
                                    context: `clubResources link`,
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.clubResources.component}-${rightSidebarNavIDs.clubResources.location}-${rightSidebarNavIDs.clubResources.id}`,
                                })}
                            >Club Resources
                            </a>
                        </div>
                        <div className={`${styles.menuSection} d-block d-lg-none`}>
                            <div
                                className={styles.menuTitle}
                                onClick={handleCollapse}
                                {...getClickAttrs({
                                    category: 'playersAndOrganizers',
                                    context: `playersAndOrganizers link`,
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.playersAndOrganizers.component}-${rightSidebarNavIDs.playersAndOrganizers.location}-${rightSidebarNavIDs.playersAndOrganizers.id}`,
                                })}
                            >Players & Organizers <span>{collapsed ? '-' : '+'}</span>
                            </div>
                            {collapsed && (
                                <div className={styles.collapsible} onClick={handleClose}>
                                    <TrackedClick
                                        eventName="Menu Cta Clicked"
                                        label="Players"
                                        traits={
                                            {
                                                sectionName: 'Organizers / Coaches',
                                                content: 'Players',
                                            }
}
                                    >
                                        <a
                                            className={`${styles.menuItem} ${pathname === '/for-players' ? styles.active : ''}`}
                                            href={`${marketingAppHost}/for-players`}
                                            {...getClickAttrs({
                                                category: 'Menu',
                                                context: `Players`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.players.component}-${rightSidebarNavIDs.players.location}-${rightSidebarNavIDs.players.id}`,
                                            })}
                                        >
                                            Players
                                        </a>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Menu Cta Clicked"
                                        label="Organizations"
                                        traits={
                                            {
                                                sectionName: 'Organizers / Coaches',
                                                content: 'Organizations',
                                            }
}
                                    >
                                        <a
                                            className={`${styles.menuItem} ${pathname === '/for-organizations' ? styles.active : ''}`}
                                            href={`${marketingAppHost}/for-organizations`}
                                            {...getClickAttrs({
                                                category: 'Menu',
                                                context: `Organizations`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.organizations.component}-${rightSidebarNavIDs.organizations.location}-${rightSidebarNavIDs.organizations.id}`,
                                            })}
                                        >
                                            Organizations
                                        </a>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Menu Cta Clicked"
                                        label="College"
                                        traits={
                                            {
                                                sectionName: 'Organizers / Coaches',
                                                content: 'College',
                                            }
}
                                    >
                                        <a
                                            className={`${styles.menuItem} ${pathname === '/pages/college-tennis' ? styles.active : ''}`}
                                            href={`${marketingAppHost}/pages/college-tennis`}
                                            {...getClickAttrs({
                                                category: 'Menu',
                                                context: `College`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.college.component}-${rightSidebarNavIDs.college.location}-${rightSidebarNavIDs.college.id}`,
                                            })}
                                        >
                                            College
                                        </a>
                                    </TrackedClick>
                                    <TrackedClick
                                        eventName="Menu Cta Clicked"
                                        label="High School"
                                        traits={
                                            {
                                                sectionName: 'Organizers / Coaches',
                                                content: 'High School',
                                            }
}
                                    >
                                        <a
                                            className={`${styles.menuItem} ${pathname === '/for-high-school-coaches' ? styles.active : ''}`}
                                            href={`${marketingAppHost}/for-high-school-coaches`}
                                            {...getClickAttrs({
                                                category: 'Menu',
                                                context: `High School`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.highSchool.component}-${rightSidebarNavIDs.highSchool.location}-${rightSidebarNavIDs.highSchool.id}`,
                                            })}
                                        >
                                            High School
                                        </a>
                                    </TrackedClick>
                                </div>
                            )}
                        </div>
                        <div className={`${styles.menuSection} d-block d-lg-none`}>
                            <div>
                                <div
                                    onClick={() => handleToggleMyAccount()}
                                    className={styles.menuTitle}
                                    {...getClickAttrs({
                                            category: 'Menu',
                                            context: ` My account`,
                                            location: 'Menu',
                                            testid: `${rightSidebarNavIDs.myAccount.component}-${rightSidebarNavIDs.myAccount.location}-${rightSidebarNavIDs.myAccount.id}`,
                                        })}
                                >My Account <span>{toggleMyAccount ? '-' : '+'}</span>
                                </div>
                                {toggleMyAccount && (
                                    <div className={styles.collapsible} onClick={handleClose}>
                                        <MenuLink
                                            path={`/settings/account`}
                                            text={'Settings'}
                                            {...getClickAttrs({
                                                category: 'myAccountSettings',
                                                context: `myAccountSettings link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.myAccountSettings.component}-${rightSidebarNavIDs.myAccountSettings.location}-${rightSidebarNavIDs.myAccountSettings.id}`,
                                            })}
                                        />
                                        {referralsEnabled && (
                                            <Link
                                                className={styles.menuItem}
                                                to="/refer-friends/member"
                                                {...getClickAttrs({
                                                    category: 'myAccountReferral',
                                                    context: `myAccountReferral link`,
                                                    location: 'Menu',
                                                    testid: `${rightSidebarNavIDs.myAccountReferral.component}-${rightSidebarNavIDs.myAccountReferral.location}-${rightSidebarNavIDs.myAccountReferral.id}`,
                                                })}
                                            >
                                                Refer a Friend
                                                {powerReferralBadge && (
                                                    <span className={styles.newBadge} data-testid="menu.my-account.refer-friends.new-badge">NEW</span>
                                                )}
                                            </Link>
                                        )}
                                        {(user.isPowered || user.isProClubHeadOrganizer || user.hasPastDueSubscription) && (
                                            <MenuLink
                                                path={`/subscriptions`}
                                                text={'Subscriptions'}
                                                {...getClickAttrs({
                                                category: 'myAccountSubscriptions',
                                                context: `myAccountSubscriptions link`,
                                                location: 'Menu',
                                                testid: `${rightSidebarNavIDs.myAccountSubscriptions.component}-${rightSidebarNavIDs.myAccountSubscriptions.location}-${rightSidebarNavIDs.myAccountSubscriptions.id}`,
                                            })}
                                            />
                                        )}
                                        {userIsFreeCollegeClubOwnerValue ? <UpgradeToUTRCollegeLink /> : <UpgradeToPowerLink />}
                                        {canUpgradeToPerformanceHs() && (
                                            <UpgradeToPerformanceHsLink />
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>
                        <div onClick={handleClose}>
                            <div className={`${styles.menuSection} pb32`}>
                                {(user.onboardingCompleted || !user.onboardingRequired) && (
                                <a
                                    className={`${isMobileWidth ? styles.menuTitle : styles.menuItem} ${pathname === '/' ? styles.active : ''}`}
                                    href={`${marketingAppHost}/`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    {...getClickAttrs({
                                        category: 'utrSports',
                                        context: `utrSports link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.utrSports.component}-${rightSidebarNavIDs.utrSports.location}-${rightSidebarNavIDs.utrSports.id}`,
                                    })}
                                >UTR Sports
                                </a>
)}
                                <a
                                    className={`${isMobileWidth ? styles.menuTitle : styles.menuItem} ${pathname === '/' ? styles.active : ''}`}
                                    href={`${links.supportHome}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    {...getClickAttrs({
                                        category: 'supportHome',
                                        context: `supportHome link`,
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.supportHome.component}-${rightSidebarNavIDs.supportHome.location}-${rightSidebarNavIDs.supportHome.id}`,
                                    })}
                                >Support
                                </a>
                                <a
                                    className={isMobileWidth ? styles.menuTitle : styles.menuItem}
                                    href="#"
                                    onClick={handleLogOut}
                                    {...getClickAttrs({
                                        category: 'Sign Out',
                                        context: 'Menu Item - Sign Out',
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.signOut.component}-${rightSidebarNavIDs.signOut.location}-${rightSidebarNavIDs.signOut.id}`,
                                    })}
                                >
                                    Sign Out
                                </a>
                            </div>
                        </div>
                        {isLocalhost && (
                            <div className={styles.menuSection}>
                                <Link
                                    className={`${styles.menuItem} ${pathname === '/test' ? styles.active : ''}`}
                                    to="/test"
                                    {...getClickAttrs({
                                        category: 'Test',
                                        context: 'Menu Item - Test',
                                        location: 'Menu',
                                        testid: `${rightSidebarNavIDs.test.component}-${rightSidebarNavIDs.test.location}-${rightSidebarNavIDs.test.id}`,
                                    })}
                                >Test
                                </Link>
                            </div>
                        )}
                    </div>
                ) : (
                    <div onClick={handleClose}>
                        <div className={styles.menuSection}>
                            <Link
                                className={`${styles.menuItem} ${pathname === '/login' ? styles.active : ''}`}
                                to="/login"
                                {...getClickAttrs({
                                    category: 'Sign in',
                                    context: 'Menu Item - Sign in',
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.signInForCoaches.component}-${rightSidebarNavIDs.signInForCoaches.location}-${rightSidebarNavIDs.signInForCoaches.id}`,
                                })}

                            >
                                <span className={styles.linkText} data-testid="menu.unauthenticated.sign-in-text">Sign in</span>
                                <span className={styles.withEmailText} data-testid="menu.unauthenticated.sign-in-with-email-text">&nbsp;with email</span>
                            </Link>
                            <Link
                                className={`${styles.menuItem} ${pathname === '/join' ? styles.active : ''} d-lg-none`}
                                to="/join"
                                {...getClickAttrs({
                                    category: 'Join',
                                    context: 'Menu Item - Join',
                                    location: 'Menu',
                                    testid: `${rightSidebarNavIDs.joinForCoaches.component}-${rightSidebarNavIDs.joinForCoaches.location}-${rightSidebarNavIDs.joinForCoaches.id}`,
                                })}

                            >
                                <span className={styles.withEmailText} data-testid="menu.unauthenticated.join-prompt-text">Don&apos;t have an account?</span>
                                <span className={styles.linkText} data-testid="menu.unauthenticated.join-text">&nbsp;Join</span>
                            </Link>
                        </div>
                    </div>
                )}
            </Menu>
            {(showLearnMoreUtrCollegePopup) && (
                <LearnMoreUtrCollegePopUp
                    data-testid="modal.menu.learn-more-college"
                    onCloseClick={() => { setShowLearnMoreUtrCollegePopup(false); }}
                    handleUpgradeClick={(ClubToUpgrade) => {
                        setShowLearnMoreUtrCollegePopup(false);
                        setShowProClubPopup(true);
                        setClubToUpgrade(ClubToUpgrade);
                    }}
                    clubOptionsToUpgrade={getCurrentFreeCollegeClubAsOptionToUpgrade()}
                />
            )}
            {(showUpgradeToPerformanceHsPopup) && (
                <UpgradeToPerformanceHsPopUp
                    onCloseClick={() => { setShowUpgradeToPerformanceHsPopup(false); }}
                    handleUpgradeClick={(ClubToUpgrade) => {
                        setShowUpgradeToPerformanceHsPopup(false);
                        setShowProClubPopup(true);
                        setClubToUpgrade(ClubToUpgrade);
                    }}
                    clubOptionsToUpgrade={getCurrentFreeHighSchoolClubAsOptionToUpgrade()}
                />
            )}
            {showProClubPopup && clubToUpgrade && (
                <UpgradeToProClubPopUp
                    data-testid="modal.menu.upgrade-pro-club"
                    skipIntro={true}
                    onCloseClick={() => { setShowProClubPopup(false); }}
                    onSuccess={handleProClubSuccess}
                    clubId={clubToUpgrade.id}
                    clubTierType={{ name: clubToUpgrade.tierTypeName }}
                    clubName={clubToUpgrade.name}
                />
            )}
        </>
    );
};

SlideMenu.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func.isRequired,
    }).isRequired,
    location: PropTypes.shape({
        pathname: PropTypes.string.isRequired,
    }).isRequired,
    featureGates: PropTypes.shape({
        REFERRAL_SYSTEM: PropTypes.string,
        POWER_REFERRAL_NEW_BADGE: PropTypes.string,
        SAVED_PLAYER_LIST_ROLLOUT: PropTypes.string,
    }).isRequired,
    checkGate: PropTypes.func.isRequired,
};

export default withRouter(withStatsig(SlideMenu));
